import { Gift } from '../gift/gift';

export class CartItem{
    gift:Gift;
    price: number;
    isEditing:boolean;
    timeAdded:number;
    giftId: string;


}



// WEBPACK FOOTER //
// ./src/app/cart/cartItem.ts